import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { NavLink, withRouter } from "react-router-dom"
import axios from 'axios'
import { connectNode } from '../../../utils/global'

import PostAddIcon from '@material-ui/icons/PostAdd'
//import '../../../styles/assets/css/pages/dashboard.css'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import EditIcon from '@material-ui/icons/Edit'
import Pagination from '../../functions/pagination'
import { appt_status } from '../../admin/variables/patient'
import { reorderData, genAppointmentStatus } from '../../functions/appointment.js'

class NoteDetails extends Component {
  constructor() {
    super(  );
    this.state = {
        appt: [],
    }
  }

  componentDidMount() {
    this.getDataList()
  }

  getDataList = () => {
    var pid = this.props.authReducer.uid
    if(this.props.match.params.pid) {
      pid = this.props.match.params.pid
    }
    axios({
      method: 'post',
      url: connectNode + 'admin/patient/get_notes',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        uid: this.props.authReducer.uid,
        pid: pid,
        nid: this.props.match.params.nid,
      }
    })
    .then((result) => {
      this.setState({
        appt: result['data'],
      })
    })
  }

  render() {
    return (
      <div className="patient_dashboard box_border4">
        <div className="row">
          <div className="small-10 columns headerPage1">
            Notes for Appointment on {this.state.appt.a_date} at {this.state.appt.appt_time}
          </div>
        </div>
        <div className="row">
          <div className="small-12 columns ">
            <div className="small-12 columns box2_2">
              {this.props.match.params.pid && <div><b>Patient: </b>{this.state.appt.pname}</div>}
              <div><b>Clinician: </b>{this.state.appt.cname}</div>
              <div><b>Notes: </b></div>
              <p>{this.state.appt.notes}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(NoteDetails)
